import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";

import "./helpers/axios";
import reportWebVitals from "./reportWebVitals";
import { PersistGate } from 'redux-persist/integration/react'; 
import {store, persistor} from "./store";
import "./i18n";
import App from "./app";

function routerBasename() {
  const raw = (process.env.PUBLIC_URL || "").trim().replace(/\/+$/, "");
  if (!raw || raw === ".") return undefined;
  return raw;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
    <React.Fragment>
      <BrowserRouter basename={routerBasename()}>
        <App />
      </BrowserRouter>
    </React.Fragment>
    </PersistGate>
  </Provider>
);
reportWebVitals();
